import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { PRODUCT_ID } from "@design-lab/shared/constants/constants";

export function useDtfPricing(enhancementTier: string = "full_enhancements") {
  return useQuery({
    enabled: !!PRODUCT_ID,
    queryKey: ["dtfPricing", PRODUCT_ID],
    queryFn: async () => {
      const pricingData = await api.dtf.dtfPricing(
        { product: PRODUCT_ID },
        {
          artworks: [
            {
              artwork_id: "simulation",
              width: 1,
              height: 1,
              quantity: 1,
              enhancement_tier: enhancementTier
            }
          ],
          pre_cut: false,
          request_source: "jiffy_made"
        }
      );

      const { artworks } = pricingData;
      const ids: any[] = Object.keys(artworks);
      const firstArtwork = artworks[ids[0]];

      return objNamesToCamelCase(firstArtwork);
    }
  });
}
